import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const years = ['2023', '2024', '2025'];
const categories = ['CIS', 'NIS', 'SRIP', 'SIS/SIP', 'PIP'];

const Year = ({ onSelect, darkMode, initialYear = null, initialCategory = null }) => {
  const [selectedYear, setSelectedYear] = useState(initialYear ?? (initialCategory ? years[years.length - 1] : null));
  const [selectedCategory, setSelectedCategory] = useState(initialCategory);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (initialYear) {
      setSelectedYear(initialYear);
    } else if (initialCategory) {
      setSelectedYear(prev => prev ?? years[years.length - 1]);
    }
  }, [initialYear, initialCategory]);

  useEffect(() => {
    if (initialCategory) {
      setSelectedCategory(initialCategory);
    } else if (initialCategory === null) {
      setSelectedCategory(null);
    }
  }, [initialCategory]);

  const handleYearClick = (year) => {
    setSelectedYear(year);
    setSelectedCategory(null);
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const handleProfileClick = () => {
    onSelect('NIS');
  };

 return (
  <Container>
    <Layout>
      <LeftPanel  >
        <SectionTitle>Current Year</SectionTitle>
        {years.map((year) => (
          <ItemButton
            darkMode={darkMode}
            key={year}
            selected={selectedYear === year}
            onClick={() => handleYearClick(year)}
          >
            {year}
          </ItemButton>
        ))}
      </LeftPanel>

      <RightPanel darkMode={darkMode}>
       {selectedYear && (
  <CategoryWrapper>
    <SectionTitle>Category</SectionTitle>
    {categories.map((category) => (
      <ItemButton
        darkMode={darkMode}
        key={category}
        selected={selectedCategory === category}
        onClick={() => handleCategoryClick(category)}
      >
        {category}
      </ItemButton>
    ))}
    </CategoryWrapper>
    )}


        {selectedCategory && (
          <div>
            <SectionTitle>Profile</SectionTitle>
            <ProfileBox
              darkMode={darkMode}
              onClick={handleProfileClick}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              IA Profile
              {isHovered && <Tooltip>Go to IA Profile</Tooltip>}
            </ProfileBox>
          </div>
        )}
      </RightPanel>
    </Layout>
  </Container>
);
};

export default Year;

// Styled-components
const Container = styled.div`
  background-color: transparent;
  padding: 10px;
  padding-top: 80px;
  font-family: Arial, sans-serif;
`;

const SectionTitle = styled.h3`
  background-color: #006400;
  color: white;
  padding: 10px;
  border-radius: 5px;
`;

const Layout = styled.div`
  display: flex;
`;

const LeftPanel = styled.div`
  width: 200px;
  padding-right: 20px;
  border-right: 2px solid #ccc;
`;

const RightPanel = styled.div`
  flex: 1;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 300px;
`;

const CategoryWrapper = styled.div`
  max-width: 200px;
`;

const ItemButton = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  border: 2px solid #006400;
  border-radius: 5px;
`;

const ProfileBox = styled(ItemButton)`
  height: 100px;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: -30px;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  white-space: nowrap;
`;
